import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useStyles } from "./ActivitesSectionStyle";
import Plumbing from "./Plumbing";
import YourActivity from "./YourActivity";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";

const ActivitesSection = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Box className={classes.MainContainer} id="vos-activites">
      <Plumbing />
      <Box className={classes.YourActivityMainWrapper}>
        <div data-aos="zoom-in">
          <Typography className={classes.YourActivitiesTitle}>
            Votre <span className={classes.YourActivitiesSpan}>Activité</span>
          </Typography>
        </div>
        <Box className={classes.YourActivityWrapper}>
          <div data-aos="flip-right">
            <YourActivity
              Title={
                <div>
                  <Typography
                    className={classes.YourActivityHeading}
                    onClick={() =>
                      window.open("https://travelbim.com", "_blank")
                    }
                  >
                    TRANSPORT ET{" "}
                    <span style={{ display: "block" }}>MOBILITÉS</span>
                  </Typography>

                  <div
                    className={classes.TravelBimWhitelogo}
                    onClick={() =>
                      window.open("https://travelbim.com/", "_blank")
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src="Logo_TRAVELBIM-white.png"
                      alt="TravelBIM Logo"
                      style={{
                        marginTop: 8,
                        marginBottom: 8,
                        height: 50,
                        width: 200,
                      }}
                    />
                  </div>
                </div>
              }
              src="TransportationIcon.svg"
              about={
                <div>
                  <Typography className={classes.CompanyIntroText}>
                    <span className={classes.SonaBimTEXT}> SONABIM </span>et{" "}
                    <span className={classes.GexiaText}>GEXIA RAIL,</span>{" "}
                    leader en solutions géomatiques,{" "}
                    <span className={classes.unissenText}>
                      unissent leurs expertises pour créer{" "}
                    </span>{" "}
                    le groupement
                  </Typography>

                  <div data-aos="flip-right">
                    <Box
                      className={clsx(
                        classes.DashedObjectiveContainer,
                        classes.TravelBimCard
                      )}
                    >
                      {" "}
                      <Typography
                        className={classes.YourActivityParatrannsport}
                      >
                        <span className={classes.NotreText}>
                          Notre objectif ?{" "}
                        </span>{" "}
                        Vous apportez{" "}
                        <span style={{ fontWeight: 500 }}>
                          des solutions toujours plus complètes et innovantes,
                          avec un seul interlocuteur privilégié{" "}
                        </span>{" "}
                        pour simplifier et accélérer tous vos projets de
                        transport et de mobilité.
                      </Typography>
                      <ul className={classes.CompanyIntroList}>
                        <li>Ferroviaires</li>
                        <li>Fluviaux</li>
                        <li>Portuaire</li>
                        <li>Site multimodale</li>
                      </ul>
                      <Button
                        variant="text"
                        className={classes.savoirBtn}
                        onClick={() => {
                          window.open(
                            "https://travelbim.com",
                            "_blank",
                            "noopener,noreferrer"
                          );
                        }}
                      >
                        En savoir plus
                      </Button>
                    </Box>
                  </div>
                </div>
              }
              linkType="external"
            />
          </div>
          <div data-aos="flip-left">
            <YourActivity
              Title={
                <div>
                  <Typography
                    className={classes.YourActivityHeading}
                    onClick={() =>
                      window.open("https://www.sonabim-industry.com/", "_blank")
                    }
                  >
                    PRODUCTION{" "}
                    <span style={{ display: "block" }}>INDUSTRIELLE</span>
                  </Typography>
                  <div
                    className={classes.TravelBimWhitelogo}
                    onClick={() =>
                      window.open("https://www.sonabim-industry.com/", "_blank")
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src="Logo_SONABIM-Industry__WHITE.png"
                      alt="TravelBIM Logo"
                      style={{
                        marginTop: 8,
                        marginBottom: 8,
                        height: 50,
                        width: 200,
                      }}
                    />
                  </div>
                </div>
              }
              src="ComplexIcon.svg"
              about={
                <div>
                  <Typography className={classes.CompanyIntroText}>
                    <span className={classes.SonaBimIndustrieText}>
                      SONABIM Industrie{" "}
                    </span>{" "}
                    vous propose des{" "}
                    <span className={classes.SolutionsText}>
                      solutions sur mesure{" "}
                    </span>{" "}
                    pour vous accompagner de la{" "}
                    <span className={classes.SonaBimIndustrieText}>
                      numérisation{" "}
                    </span>{" "}
                    la plus fine à l'{" "}
                    <span className={classes.SonaBimIndustrieText}>
                      exploitation connectée{" "}
                    </span>{" "}
                    de vos installations.
                  </Typography>
                  <div data-aos="flip-left">
                    <Box
                      className={clsx(
                        classes.DashedObjectiveContainer,
                        classes.MarginTopExtra
                      )}
                    >
                      <Typography className={classes.IndustryFocusText}>
                        <span className={classes.NotreText}>
                          {" "}
                          Notre objectif ?
                        </span>{" "}
                        Une gestion{" "}
                        <span style={{ fontWeight: 500 }}>
                          des données optimisée et des installations
                          ultra-performantes{" "}
                        </span>{" "}
                        pour un pilotage intelligent.
                      </Typography>
                      <Box className={classes.SectorListBlock}>
                        <Typography className={classes.SectorIntroText}>
                          Nous intervenons dans les secteurs:
                        </Typography>
                        <ul className={classes.CompanyIntroList}>
                          <li>Extraction Minière</li>
                          <li>Industrie manufacturière</li>
                          <li>Production d’électricité</li>
                        </ul>
                      </Box>

                      <Button
                        variant="text"
                        className={clsx(
                          classes.savoirBtn,
                          classes.ButtonMarginTopExtra
                        )}
                        onClick={() =>
                          window.open(
                            "https://www.sonabim-industry.com/",
                            "_blank"
                          )
                        }
                      >
                        En savoir plus
                      </Button>
                    </Box>
                  </div>
                </div>
              }
              linkType="internal"
            />
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default ActivitesSection;
